import React from 'react';
import _ from 'lodash';
import InfinityScrollLoad from '../InfinityScrollLoad';
import Tippy from '../ReactTippy';
import { checkSelectedAll } from '../../utilities/commonUtil';
import { messageUtility } from '../../utilities/messageUtility';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';

/**
 * 複数選択に対応したセレクトボックス：決定ボタンなし
 * 検索機能も含む
 * API通信ができる
 * @props {string}label: セレクトボックスの初期値
 * @props {string}className: 個別でCSSを追加したい時に指定するクラス名
 * @props {object}dropdownSelectStyle: ドロップダウンのstyle
 * @props {string}widthClass: 横幅を指定するクラス名
 * @props {string}itemWidthClass: アイテムリストの横幅を指定するクラス名
 * @props {string}placeholder: 検索テキストボックスのプレースホルダー
 * @props {function}onSelect: 選択ボタンを実行した時に呼び出し元にデータを返す
 * @props {function}onLoadData: callback for this.loadData
 * @props {array}options: optionタグで表示させるデータ (データがあると初回ローディングを実行しない)
 * @props {string}valueName: optionタグのvalueに設定したい配列内のKey名
 * @props {string}keyName: 画面に表示したい配列内のKey名
 * @props {string}scrollHeight: ドロップダウンの縦長を決めるstyle
 * @props {boolean}isDisabled: show dropdown but disable to select or open
 * @props {string}disableOptionName: key name in the array that is used to disable option tag
 * @props {boolean}hasTooltipOnHeader: if false then dropdown-header doesn't have tooltip
 * @props {boolean}autoHideTooltipOnOption: if false then dropdown-option always has tooltip
 *
 * @API
 * @props {object}apiParams: データ取得APIで必要なパラメーター情報
 * @props {number}limit: APIでデータを取得する時の検索上限
 * @props {string}apiSearchKey: データ取得APIで検索したいproperty名 (ex: 作業員名で検索なら'worker_name'など)
 * @props {string}apiBindDataKey: データ取得APIのレスポンスの配列のKey名 (ex: response.data.entities.xxx の 'xxx'の部分)
 * @props {function}apiProcess: 『apiBindDataKey』を設定しなかった時に呼び出し元にresponseデータを返す
 * @props {function}api: データ取得API通信ファンクション (Promiseデータ)
 * @props {number}isLimit: 一度の検索に抽出する件数指定のフラグ 1: true その他: false
 */
export default class MultiSelectDropdownSaveOnClose extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      loaded: !this.props.api || this.props.options ? true : false,
      allLoaded: false,
      opened: false,
      hiddenSelectedOptions: [], // 選択要素保持
      selectAll: this.props.selectAll || false, // 全選択フラグ
      condition: {
        name: '', // 検索対象文字列
      },
      label: this.props.label || '未選択', // 未選択時ラベル名
      selected: this.props.selected || [], // 選択要素
      selectedName: '', // 選択要素名(初期表示の検索で値がない場合)
      className: this.props.className || '', // 追加クラス名
      placeholder:
        this.props.placeholder || messageUtility.getMessage('I-000-090'), // 検索フォームプレースホルダ
      options: this.props.options || [], // 選択項目リスト
      api: this.props.api || null, // API Promiseオブジェクト
      apiParams: this.props.apiParams || {}, // APIパラメータ
      apiSearchKey: this.props.apiSearchKey || '', // API検索キー (指定しない場合は検索不可)
      apiProcess:
        this.props.apiProcess ||
        function(response) {
          console.log(response);
        }, // APIリクエスト後のレスポンス処理
      apiBindDataKey: this.props.apiBindDataKey || null, // reponse.data.entities.のあとのキー(ショートカット)
      offset: 0, // API問い合わせオフセット
      valueName: this.props.valueName || 'id', // 値オブジェクト名
      keyName: this.props.keyName || 'name', // キーオブジェクト名
      isLimit: this.props.isLimit || 1, // 一度の検索に抽出する件数指定のフラグ 1: true その他: false
      limit: this.props.limit || 30, // 一度の検索に抽出する件数
      isLoading: this.props.options ? false : true, // ロード中フラグ
      dropdownSelectStyle: this.props.dropdownSelectStyle || { width: '165px' },
      isDisabled: this.props.isDisabled || false,
      disableOptionName: this.props.disableOptionName || null,
      hasTooltipOnHeader: this.props.hasTooltipOnHeader !== false, //default true
      autoHideTooltipOnOption: this.props.autoHideTooltipOnOption !== false, //default true
    };

    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.parent = React.createRef();
    this.searchTimer;

    this.uid = _.uniqueId();
    this.tippyRef = React.createRef();
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.api) {
      this.loadData();
    } else {
      this.setState({
        isLoading: false,
        loaded: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (
      !_.isEqual(prevProps.selected, this.props.selected) &&
      !_.isEqual(this.props.selected, this.state.selected)
    ) {
      const selected = _.cloneDeep(this.props.selected);
      const selectAll = checkSelectedAll(
        selected,
        _.map(this.state.options, this.state.valueName)
      );
      this.setState({
        selected,
        selectAll,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }

    // プルダウンの呼び出しコンポーネントでの処理
    this.props.onSelect(this.state.selected);

    const state = _.cloneDeep(this.state);
    state.opened = false;
    this.setState(state);
  };

  handleOpen = e => {
    if (this.state.isDisabled) {
      e.preventDefault();
      return;
    }
    const targetPosition = _.isFunction(this.props.jumpToShowDropdown)
      ? e.target.getBoundingClientRect()
      : null;

    if (!this.state.opened) {
      //ie対応 Tippyを先に非表示にしないとドロップダウンが正しく表示されない
      if (this.tippyRef && this.tippyRef.current !== null) {
        this.tippyRef.current.hide(0); //0にして即時に閉じるようにする必要がある
      }

      this.setState({ opened: true }, () => {
        if (_.isFunction(this.props.jumpToShowDropdown)) {
          this.props.jumpToShowDropdown(targetPosition);
        }
      });
    }

    e.preventDefault();
  };

  setCondition = e => {
    const name = e.target.value;
    this.setState(
      prevState => ({
        condition: { ...prevState.condition, name },
      }),
      () => {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          this.search();
        }, 1000);
      }
    );
  };

  search = () => {
    this.setState(
      {
        hiddenSelectedOptions: this.mergeHiddenSelectedOptionsWithSelectedOptions(),
        loaded: false,
        allLoaded: false,
        offset: 0,
        options: [],
        isLoading: true,
      },
      () => {
        this.loadData();
      }
    );
  };

  handleInview = () => {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState(
        {
          loaded: false,
        },
        () => {
          this.loadData();
        }
      );
    }
  };

  /**
   * 選択時のイベント
   * @param {string} value // id
   * @param {boolen} checked
   */
  // BLDE_V2-50226 0の値も使えるように
  handleSelectedRow = (value, checked, name) => {
    let selected = _.filter(
      this.state.selected,
      i => i !== null && i !== undefined && !_.isNaN(i)
    );
    if (value || value == 0) {
      if (checked) {
        selected = _.union(selected, [value]);
      } else {
        selected = _.pull(selected, value);
      }
    }

    const selectedName = _.join(
      _.map(
        _.filter(this.state.options, op =>
          _.includes(selected, op[this.state.valueName])
        ),
        this.state.keyName
      ),
      ','
    );
    const hiddenSelectedOptions = this.mergeHiddenSelectedOptionsWithSelectedOptions();
    const selectAll = checkSelectedAll(
      selected,
      _.map(this.state.options, this.state.valueName)
    );
    this.setState(
      {
        selected,
        selectedName,
        hiddenSelectedOptions,
        selectAll,
      },
      () => {
        this.props.onSelect(this.state.selected, [value], checked);
      }
    );
  };

  /**
   * 全て選択時のイベント
   */
  handleSelectAll = () => {
    const selectedAll = this.state.selectAll;
    const state = _.cloneDeep(this.state);

    const rows = _.map(
      _.filter(state.options, option => !option[state.disableOptionName]),
      state.valueName
    );

    if (!selectedAll) {
      state.selected = _.union(state.selected, rows);
    } else {
      _.each(rows, row => {
        _.pull(state.selected, row);
      });
    }

    state.selectAll = !selectedAll;
    state.selectedName = _.join(
      _.map(this.state.options, option => option[this.state.keyName]),
      ','
    );
    state.hiddenSelectedOptions = this.mergeHiddenSelectedOptionsWithSelectedOptions();
    this.setState(state, () => {
      this.props.onSelect(this.state.selected, rows, state.selectAll);
    });
  };

  /**
   * APIコール
   * this.state.api: Service.api
   * this.state.apiParams: params
   * this.state.apiProcess: (response)=>{const option = response.data.entities.data;return option;} // id/nameのリストを返す
   * Service.api(params).then((response)=>{data = response.data.entities.data;return data}).then((data)=>console.log(data))
   * @param {function} notify
   */
  loadData = async () => {
    if (this.state.loaded || !this._isMounted) {
      return;
    }
    const size = _.size(this.state.options);
    let params = _.assign({}, this.state.apiParams, {
      is_limit: this.state.isLimit,
      limit: this.state.limit,
      offset: size,
    });

    if (this.state.condition.name !== '') {
      // name
      params = _.assign({}, params, {
        [this.state.apiSearchKey]: this.state.condition.name,
      });
    }

    const doApi = async () => {
      return this.state
        .api(params)
        .then(response => {
          const { onLoadData } = this.props;
          const { condition } = this.state;
          onLoadData && onLoadData(response, condition);

          let res;
          if (!this.state.apiBindDataKey) {
            res = this.state.apiProcess(response);
          } else {
            res = {
              data: response.data.entities[this.state.apiBindDataKey],
              total: response.data.total,
            };
          }
          return res;
        })
        .then(newOptions => {
          const data = newOptions.data;

          const allLoadedLimit = params.limit;
          const allLoaded = _.size(data) < allLoadedLimit;
          let options = _.clone(this.state.options);

          _.each(data, datum => {
            let findedRowIndex = _.findIndex(options, option => {
              return (
                option[this.state.valueName] === datum[this.state.valueName]
              );
            });
            if (findedRowIndex < 0) {
              options.push(datum);
            }
          });
          const selectAll = checkSelectedAll(
            this.state.selected,
            _.map(options, this.state.valueName)
          );

          this.setState({
            options,
            loaded: true,
            allLoaded,
            selectAll,
            isLoading: false,
          });
        });
    };
    await doApi();
  };

  /**
   * 選択要素保持
   */
  mergeHiddenSelectedOptionsWithSelectedOptions = () => {
    const selected = this.state.selected;

    // 現在dropdownのoptionsより
    const options = _.filter(this.state.options, op =>
      _.includes(selected, op[this.state.valueName])
    );

    // 検索前のdropdownより取得した選択要素より
    _.each(this.state.hiddenSelectedOptions, hiddenOption => {
      if (
        _.filter(options, tempHiddenOption => {
          return (
            tempHiddenOption[this.state.valueName] ===
            hiddenOption[this.state.valueName]
          );
        }).length === 0 &&
        _.includes(selected, hiddenOption[this.state.valueName])
      ) {
        options.push(hiddenOption);
      }
    });
    return options;
  };

  /**
   * optionタグがチェックされているか確認する
   * @param {object}option: 表示行
   */
  checkedOption = option => {
    return _.includes(this.state.selected, option[this.state.valueName]);
  };

  render() {
    const getName = () => {
      let name = this.state.label;
      if (this.state.selected.length > 0) {
        const options = this.mergeHiddenSelectedOptionsWithSelectedOptions();

        if (options && options.length > 0) {
          name = _.join(_.map(options, this.state.keyName), ',');
        } else {
          name = this.state.selectedName || this.state.label;
          if (_.isArray(name)) {
            name = _.join(name, ',');
          }
        }
      }
      return name;
    };

    const gotName = getName();

    return (
      <div
        className={`dropdown-multi-select${
          this.state.className !== '' ? ` ${this.state.className}` : ''
        }${this.state.isDisabled ? ' dropdown-multi-select--disabled' : ''}`}
        ref={this.parent}
      >
        <div
          className={`dropdown-multi-select__header ${
            this.state.opened ? ' show' : ''
          }`}
        >
          {this.state.hasTooltipOnHeader ? (
            <Tippy
              duration={10}
              arrow={true}
              arrowType='sharp'
              placement='bottom'
              maxWidth='160px'
              ref={this.tippyRef}
              html={
                <div
                  style={{
                    fontSize: '10px',
                    lineHeight: '16px',
                    textAlign: 'left',
                    color: 'white',
                  }}
                >
                  {/* ツールチップ */}
                  {gotName}
                </div>
              }
            >
              <a
                href=''
                className={`dropdown-select${this.state.opened ? ' show' : ''}`}
                onClick={this.handleOpen}
                style={this.state.dropdownSelectStyle}
              >
                <span
                  className={`dropdown-select__txt${
                    this.state.expandable ? ' expandable' : ''
                  }`}
                >
                  {gotName}
                </span>
              </a>
            </Tippy>
          ) : (
            <a
              href=''
              className={`dropdown-select${this.state.opened ? ' show' : ''}`}
              onClick={this.handleOpen}
              style={this.state.dropdownSelectStyle}
            >
              <span
                className={`dropdown-select__txt${
                  this.state.expandable ? ' expandable' : ''
                }`}
              >
                {gotName}
              </span>
            </a>
          )}
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
        {this.state.opened && (
          <div className='dropdown dropdown--dropdown-list show'>
            <div
              className={`dropdown__item ${
                !_.isUndefined(this.props.widthClass)
                  ? this.props.widthClass
                  : ''
              } ${this.props.isHideHiddenItem ? '' : 'dropdown__item--hidden'}`}
            >
              {this.state.apiSearchKey !== '' && (
                <div className='dropdown-multi-select__item'>
                  <i className='i-search i-2x' />
                  <input
                    type='text'
                    id={`searchKey${this.uid}`}
                    className='SearchDropdown'
                    defaultValue={this.state.condition.name}
                    name='search'
                    placeholder={messageUtility.getMessage('I-000-090')}
                    onChange={this.setCondition}
                  />
                </div>
              )}
              {
                <div className='dropdown-multi-select__item'>
                  <div className='dropdown-multi-select__checkall'>
                    <div className='btn-checkbox'>
                      <label htmlFor={`checkall-group-${this.uid}`}>
                        <input
                          id={`checkall-group-${this.uid}`}
                          type='checkbox'
                          checked={this.state.selectAll}
                          onClick={this.handleSelectAll}
                        />
                        <i className='i-square-checkbox i-2_5x' />
                      </label>
                    </div>
                    {/* ラベルクリックでラジオボタン選択のため(全選択) */}

                    {/* ツールチップ */}
                    {
                      <Tippy
                        duration={10}
                        arrow={true}
                        arrowType='sharp'
                        placement='bottom'
                        // maxWidth='160px'
                        html={
                          <div
                            style={{
                              fontSize: '10px',
                              lineHeight: '16px',
                              textAlign: 'left',
                              color: 'white',
                            }}
                          >
                            全選択する場合は最下部までスクロールしてください
                          </div>
                        }
                      >
                        <label htmlFor={`checkall-group-${this.uid}`}>
                          {messageUtility.getMessage('I-000-092')}
                        </label>
                      </Tippy>
                    }
                  </div>
                </div>
              }
              <div className='dropdown-multi-select__item'>
                <div
                  className='dropdown-multi-select__scroll'
                  id={this.targetId}
                  style={this.props.scrollHeight}
                >
                  <ul className={'multi-select'}>
                    {_.map(this.state.options, option => (
                      <SelectableOption
                        key={option[this.state.valueName]}
                        option={option}
                        checked={this.checkedOption(option)}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        state={this.state}
                        itemWidthClass={
                          !_.isUndefined(this.props.itemWidthClass) &&
                          this.state.opened === true
                            ? this.props.itemWidthClass
                            : ''
                        }
                      />
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      isLoading={this.state.isLoading}
                      callback={this.handleInview}
                      ignoreIndicator={true}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

/**
 * Tooltipで表示される文字
 * @param data {string}
 */
export const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

/**
 * tooltip表示判定
 * @param {object} instance // tippy
 */
export const setTippyHide = instance => {
  const targetOption = document.getElementsByClassName(
    `${instance.options.role}`
  );
  if (targetOption && targetOption[0]) {
    const _width =
      targetOption[0].parentElement.offsetWidth - // .multi-select__item
      targetOption[0].previousSibling.offsetWidth; // .btn-checkbox
    // 表示文字の長さ > 実際の文字の長さ
    instance.popper.hidden = _width > targetOption[0].scrollWidth;
  }
};

const SelectableOption = ({
  option,
  checked,
  targetId,
  handleSelectedRow,
  state,
  itemWidthClass,
}) => {
  const isDisabledOption = option[state.disableOptionName];
  return (
    <li
      className={`multi-select__item ${itemWidthClass} ${
        isDisabledOption ? 'multi-select__item-disabled' : ''
      }`}
    >
      <div className='btn-checkbox'>
        <label
          htmlFor={`single-field-a-item-id-${
            option[state.valueName]
          }-${targetId}`}
        >
          <input
            id={`single-field-a-item-id-${option[state.valueName]}-${targetId}`}
            type='checkbox'
            checked={checked}
            disabled={isDisabledOption}
            onClick={() =>
              handleSelectedRow(
                option[state.valueName],
                !checked,
                option[state.keyName]
              )
            }
          />
          <i className='i-square-checkbox i-2_5x' />
        </label>
      </div>

      {/* tooltip */}
      <Tippy
        duration={10}
        followCursor={true}
        placement='bottom'
        role={`tippy_target_${targetId}_${option[state.keyName]}_${
          option[state.valueName]
        }`}
        html={renderTooltipContent(option[state.keyName])}
        onShow={instance => {
          if (state.autoHideTooltipOnOption) {
            setTippyHide(instance);
          }
        }}
      >
        <div
          className={`multi-select__label tippy_target_${targetId}_${
            option[state.keyName]
          }_${option[state.valueName]}`}
          onClick={() =>
            !isDisabledOption &&
            handleSelectedRow(
              option[state.valueName],
              !checked,
              option[state.keyName]
            )
          }
        >
          {option[state.keyName]}
        </div>
      </Tippy>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/MultiSelectDropdownSaveOnClose.jsx